import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { BaseApiEndpointService } from './base-api-endpoint.service';
import { UsersEndpoint } from './models/users-endpoint.model';
import { AppConfigState } from '@nibtravel/shared/util/app-config';

@Injectable({ providedIn: 'root' })
export class UserApiEndpointService extends BaseApiEndpointService {
  constructor(protected store: Store) {
    super(store, 'user');
  }

  getRegisterUserUrl(brand: string): string {
    return this.constructUrl(UsersEndpoint.user(brand));
  }

  getKosmosRegisterUser(): string {
    const baseUrl = this.getKosmosUrl();
    const path = UsersEndpoint.kosmosCreateAccount();
    return `${baseUrl}${path}`;
  }

  getKosmosLogin(): string {
    const baseUrl = this.getKosmosUrl();
    const path = UsersEndpoint.kosmosLogin();
    return `${baseUrl}${path}`;
  }

  private getKosmosUrl(): string {
    return this.store.selectSnapshot((state) =>
      AppConfigState.getApiUrl(state.appConfig, 'kosmos')
    );
  }
}
